import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// Validation schema
const validationSchema = Yup.object().shape({
  riskType: Yup.string().required("Risk Type is required"),
  loadFactor: Yup.number()
    .required("Load Factor is required")
    .typeError("Load Factor must be a number"),
});

export default function RiskPricingForm() {
  const [loadFactorValue, setLoadFactorValue] = useState("");

  const initialValues = {
    riskType: "",
    loadFactor: "",
  };

  const riskTypeOptions = [
    { value: "fire", label: "Fire" },
    { value: "theft", label: "Theft" },
    { value: "accident", label: "Accident" },
  ];

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setTimeout(() => {
      alert("Risk Pricing saved! (UI only)");
      setSubmitting(false);
      resetForm();
      setLoadFactorValue("");
    }, 500);
  };

  return (
    <div className="p-4 bg-white rounded shadow-sm my-4">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form className="mb-3">
            <div className="row g-3">
              {/* Risk Type Select */}
              <div className="col-md-6">
                <label htmlFor="riskType" className="form-label fw-semibold">
                  Risk Type
                </label>
                <Field
                  as="select"
                  name="riskType"
                  className="form-select form-control"
                >
                  <option value="">Select Risk Type</option>
                  {riskTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="riskType"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>

              {/* Load Factor Input */}
              <div className="col-md-6">
                <label htmlFor="loadFactor" className="form-label fw-semibold">
                  Load Factor
                </label>
                <Field
                  name="loadFactor"
                  type="number"
                  className="form-control"
                  onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue("loadFactor", value);
                    setLoadFactorValue(value);
                  }}
                />
                <ErrorMessage
                  name="loadFactor"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>
            </div>

            {/* Centered Buttons showing loadFactor value */}
            <div
              className="button-group"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                marginTop: "24px",
              }}
            >
              {["Tonnage", "Seating Capacity", "Year > 3"].map((label) => (
                <button
                  key={label}
                  type="button"
                  className="custom-btn"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "12px 16px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                  }}
                >
                  <span>{label}</span>
                  <span style={{ fontSize: "12px", color: "#555" }}>
                    {loadFactorValue || 0}
                  </span>
                </button>
              ))}
            </div>

            {/* Save Button */}
            <div className="d-flex justify-content-end mt-4" style={{ gap: "24px" }}>
              <button
                type="submit"
                className="btn btn-success px-4 py-2"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save Risk Pricing"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
